import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { EmailTemplate } from "@redotech/redo-marketing-templates-common/email-template";
import { SmsTemplate } from "@redotech/redo-marketing-templates-common/sms-template";
import { RedoMerchantEmailTemplatesRpcClientContext } from "@redotech/redo-merchant-app-common/email-templates-rpc-client-provider";
import { RedoMerchantSmsTemplatesRpcClientContext } from "@redotech/redo-merchant-app-common/sms-templates-rpc-client-provider";
import { createContext, ReactNode } from "react";

export interface AutomationContext {
  emailTemplates: EmailTemplate[];
  originEmailTemplates: EmailTemplate[];
  smsTemplates: SmsTemplate[];
}

export const AutomationContext = createContext<AutomationContext | null>(null);

export const AutomationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const emailTemplatesRpcClient = useRequiredContext(
    RedoMerchantEmailTemplatesRpcClientContext,
  );
  const smsTemplatesRpcClient = useRequiredContext(
    RedoMerchantSmsTemplatesRpcClientContext,
  );
  const emailTemplatesLoad = useLoad(
    async (signal) =>
      await emailTemplatesRpcClient.getEmailTemplates({}, { signal }),
    [emailTemplatesRpcClient],
  );
  const originEmailTemplatesLoad = useLoad(
    async (signal) =>
      await emailTemplatesRpcClient.getOriginEmailTemplates({}, { signal }),
    [emailTemplatesRpcClient],
  );
  const smsTemplatesLoad = useLoad(async () => {
    const templates = await smsTemplatesRpcClient.paginateSmsTemplates({
      page: 1,
      pageSize: 1000,
    });
    return templates.data;
  }, [smsTemplatesRpcClient]);

  return (
    <AutomationContext.Provider
      value={{
        emailTemplates: emailTemplatesLoad.value || [],
        originEmailTemplates: originEmailTemplatesLoad.value || [],
        smsTemplates: smsTemplatesLoad.value || [],
      }}
    >
      {children}
    </AutomationContext.Provider>
  );
};
